import React, {Component} from 'react';

import Workflow from "../core/Workflow";
import axios from "axios";
import AuthService from "../../AuthService";

class Ville extends Component {
    constructor(props) {
        super(props);

        this.wowkflow = React.createRef();
        this.state = {
            workflowInitData : {
                WORKFLOW_ID: 13,
                PARAM_rootId: this.props.match.params.rootId,
                PARAM_utilisateurId: 1, // TODO récupérer l'ID du localStorage stocké à partir du token
                bateauList: [],
                assoVilleBateauList: []
            },
            rootId: this.props.match.params.rootId,
        }
        this.loadData(this.state.rootId);
        this.coreChange = this.coreChange.bind(this);
        this.coreSubmit = this.coreSubmit.bind(this);
        this.coreExternalCall = this.coreExternalCall.bind(this);
    }

    async loadData(villeId) {
        await axios.post(AuthService.getUrl('/getBateauxByVille'), {villeId: this.state.rootId}, AuthService.getAuthHeader()).then(res => {
            this.setState({
                bateauList: res.data.data['bateauList'],
                assoVilleBateauList: res.data.data['assoVilleBateauList']
            });
        });
    }

    async checkBateau(e) {
        let value = e.target.value;
        await axios.post(AuthService.getUrl('/setBateauByVille'), {bateauId: value , villeId: this.state.rootId}, AuthService.getAuthHeader()).then(res => {
        });
        await this.loadData(this.state.rootId);
    }

    isAssociated(bateauId) {
        for (const asso of this.state.assoVilleBateauList) {
            if (asso.bateau.id === bateauId) return true;
        }
        return false;
    }

    coreChange(e) {
    }

    async coreExternalCall(method) {
        if (method === "delete") {
            await axios.post(AuthService.getUrl('/deleteVille'), {id: this.state.rootId}, AuthService.getAuthHeader()).then(
                res => {
                    this.props.history.push('/admin/villes');
                }
            );
        }
        if (method === "leave") {
            this.props.history.push('/admin/villes');
        }
    }

    coreSubmit(data) {
    }

    render() {
        return (
            <div className="responsiveForm">
                {!!(this.state.errorMessage) &&
                    <div className="errorMessage">
                        <span>{this.state.errorMessage}</span>
                    </div>
                }
                {!!(this.state.validMessage) &&
                    <div className="actionMessage">
                        <span>{this.state.validMessage}</span>
                    </div>
                }
                <Workflow   ref={this.wowkflow}
                            initData={this.state.workflowInitData}
                            onChange={this.coreChange}
                            onSubmit={this.coreSubmit}
                            externalCall={this.coreExternalCall}
                            primaryKey={this.state.rootId}/>
                {<div name="Bateaux">
                    {this.state.bateauList?.map(bateau => (
                        <div>
                            <input type="checkbox" id={bateau.id} value={bateau.id} checked={this.isAssociated(bateau.id)} onChange={e => this.checkBateau(e)}/>
                            <label htmlFor="scales">{bateau.nom}</label>
                        </div>
                    ))}
                </div>}
            </div>
        );
    }
}

export default Ville;
